import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store";
import "./i18n";
import "./index.css";
import App from "./App.tsx";

// Redirect hash-based routes (e.g., /#/about) to non-hash routes (e.g., /about)
if (window.location.hash && window.location.hash.startsWith("#/")) {
  const newPath = window.location.hash.replace("#", "");
  history.replaceState(null, "", newPath);
}

const ALLOWED_API_ORIGINS = [
  /^https:\/\/stridr-backend-pr-\d+\.fly\.dev$/,
  /^https:\/\/api\.stridr\.app$/,
];
const _apiParam = new URLSearchParams(window.location.search).get("api");
if (_apiParam && ALLOWED_API_ORIGINS.some((re) => re.test(_apiParam))) {
  localStorage.setItem("SERVER", _apiParam);
  const _url = new URL(window.location.href);
  _url.searchParams.delete("api");
  history.replaceState(null, "", _url.toString());
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </StrictMode>
);
